<template>
  <div>
    <div class="admin_title">问卷调查</div>
    <!--右侧内容-->
    <div class="gj_top_class">
      <input type="button" class="btn_s_gj" @click="searchByFilter(filter)" /><input type="text" class="put_gj"  v-model="filter.title" @keyup.13="searchByFilter(filter)"/>
      <select v-model="filter.largeType" @change="getMiddleTypes(filter.largeType)">
        <option :value="''">(全部)大分类</option>
        <option v-for='item in largeTypes' :key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <select v-model="filter.middleType" @change="searchByFilter(filter)">
        <option :value="''">(全部)小分类</option>
        <option v-for='item in middleTypes' :key="item.middleType" :value="item.middleType">{{item.middleTypeLabel}}</option>
      </select>
      <a @click="editQuestionnaire('')" class="btn btn_add">新增问卷</a>
    </div>
    <div class="question_list">
      <dl v-for="item in list" style="position: relative;" :key="item.id" :class="{ 'color_a': judgmentState(item.startDate, item.endDate) === 'over', 'color_c': judgmentState(item.startDate, item.endDate) === 'start', 'color_e': judgmentState(item.startDate, item.endDate) === 'willStart' }">
        <span class="enroll_badge" style="position: absolute; top: -12px; z-index: 12;">{{item.isPublish=='1' ? '已上架' : '已下架'}}</span>
        <a title="复制" @click="copyExam(item.id)" style="position: absolute; right: 5px; cursor: pointer;"><i class="el-icon-document" style="color: white;"></i></a>
        <a title="删除" @click="delExam(item.id)" style="position: absolute; right: 25px; cursor: pointer;"><i class="el-icon-delete" style="color: white;"></i></a>
        <a href="javascript:;" @click="editQuestionnaire(item.id)"><h3>{{item.title}}</h3></a>
        <p class="left_c"> <span>参与人数</span><br />
          <span><i>{{item.isUsed}}</i><b>人</b></span> </p>
        <p class="right_c"> <span>总人数</span><br />
          <!--<span><i>20012</i><b>人</b></span>--> <span><b>不限</b></span></p>
        <dd> <span v-if="judgmentState(item.startDate, item.endDate) === 'over'">已结束</span><span v-if="judgmentState(item.startDate, item.endDate) === 'willStart'">未开始</span><span v-if="judgmentState(item.startDate, item.endDate) === 'start'">进行中</span><a href="javascript:;" @click="showStatistics(item.id)">统计明细</a> </dd>
      </dl>
      <h5 class="none_ts" v-if="cnt <= 0">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
    </div>
    <div class="zy_list_bottom mt-30">
      <dl>
        <dt><!--<input id="sel_1" onchange="selectAll()" type="checkbox" value="1" style="opacity: 1;"/> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/> <input name="" type="button" value="删除所选"  class="btn_zy_bottom" />-->共{{cnt}}个问卷</dt>
        <dd v-if="cnt>0">
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>

import Dropdown from '@/store/modules/dropdowns'
import {init} from '@/assets/js/public'
import s_query from '@/utils/s_query'
import { getCookie } from '@/store/cookies'
import Paginate from 'vuejs-paginate'
export default {
  components: { Paginate },
  data () {
    return {
      Dropdown: Dropdown,
      filter: {
        pageNo: 1,
        pageSize: 9,
        type: '2',
        title: '',
        largeType: '',
        middleType: ''
      },
      list: [],
      pages: 0,
      cnt: 0,
      timestamp: (new Date()).getTime(),
      largeTypes: [],
      middleTypes: [],
      prefix: this.$route.meta.prefix || ''
    }
  },
  created () {
    if (getCookie('query_record') && getCookie('query_record')[this.$route.path]) {
      this.filter = getCookie('query_record')[this.$route.path]
    }
    this.getQuestionnaires(this.filter)
    this.getLargeTypes()
  },
  mounted () {
    this.$nextTick(() => {
      init()
    })
  },
  computed: {},
  methods: {
    clickCallback (pageNum) {
      this.filter.pageNo = pageNum
      this.getQuestionnaires(this.filter)
    },
    resetPagination () {
      this.filter.pageNo = 1
      if (this.$refs.paginate) {
        this.$refs.paginate.selected = 0 // 重置 active-class为第一页
      }
    },
    judgmentState (startDate, endDate) {
      let S_timestamp = this.$utils.transformDateStr(startDate)
      let E_timestamp = this.$utils.transformDateStr(endDate)
      if (this.timestamp >= S_timestamp && this.timestamp <= E_timestamp) {
        return 'start'
      } else if (this.timestamp > E_timestamp) {
        return 'over'
      } else if (this.timestamp < S_timestamp) {
        return 'willStart'
      }
    },
    getLargeTypes () {
      this.$api.post(this.$global.examApiPath, '/dict/get', {type: 'examPaperLargeType'}, r => {
        this.largeTypes = r.data
      })
    },
    getMiddleTypes (largeType) {
      this.$api.post(this.$global.examApiPath, '/examTypeRel/search', {largeType: largeType,  middleType: 'examPaperMiddleType', select: '1'}, r => {
        this.middleTypes = r.data
        this.searchByFilter(this.filter)
      })
    },
    searchByFilter () {
      this.resetPagination()
      this.getQuestionnaires(this.filter)
    },
    getQuestionnaires (filter) {
      s_query.save(this.$route.path, filter)
      this.$api.post(this.$global.examApiPath, '/examPaper/search', filter, r => {
        this.cnt = r.cntData
        this.pages = Math.ceil(r.cntData / this.$global.paginationOptions.page_num)
        if (r.data && r.data.length>0) {
          this.list = r.data
        } else {
          this.list = []
        }
        this.$emit('data-prepared')
        this.$nextTick(() => { // 数据初始化时分页组件需要手动更新
          if (this.$refs.paginate) {
            this.$refs.paginate.selected = this.filter.pageNo - 1
          }
        })
      })
    },
    copyExam (id) {
      this.$api.post(this.$global.examApiPath, '/examPaper/copy', {id: id}, r => {
        this.getQuestionnaires(this.filter)
      })
    },
    delExam (id) {
      this.$api.post(this.$global.examApiPath, '/examPaper/delete', {id: id}, r => {
        this.getQuestionnaires(this.filter)
      })
    },
    editQuestionnaire (id) {
      if (id == '') {
        id = 'create'
      }
      this.$router.push({path: this.prefix + '/org/questionnaire/'+ id})
    },
    showStatistics (id) {
      this.$router.push({path: this.prefix + '/org/questionnaireStat/'+ id})
    }
  }
}
</script>
<style lang="scss">
  .enroll_badge {
    background-color: #f56c6c;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/questionnaire/list.vue